import { render, staticRenderFns } from "./wagesSettings.vue?vue&type=template&id=47ef0f06&scoped=true&"
import script from "./wagesSettings.vue?vue&type=script&lang=js&"
export * from "./wagesSettings.vue?vue&type=script&lang=js&"
import style0 from "./wagesSettings.vue?vue&type=style&index=0&id=47ef0f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ef0f06",
  null
  
)

export default component.exports